<template>
  <div class="portfolio-page">
    <!-- ========================================== -->
    <!-- هدر -->
    <!-- ========================================== -->
    <div class="page-header">
      <div>
        <h2>📸 نمونه کارها</h2>
        <p class="subtitle">مدیریت پست‌های نمونه کار سالن</p>
      </div>
      <button class="btn-primary" @click="openCreateModal">
        ➕ پست جدید
      </button>
    </div>

    <!-- ========================================== -->
    <!-- نوار مصرف دیسک -->
    <!-- ========================================== -->
    <disk-usage-bar :disk-usage="diskUsage" />

    <!-- ========================================== -->
    <!-- فیلترها -->
    <!-- ========================================== -->
    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-group">
          <label>دسته‌بندی</label>
          <select v-model="filters.line_id" class="filter-select" @change="loadPosts">
            <option value="">همه</option>
            <option v-for="line in lines" :key="line.id" :value="line.id">
              {{ line.title }}
            </option>
          </select>
        </div>
        <button class="btn-reset" @click="resetFilters">⟳ پاک کردن</button>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- لیست پست‌ها -->
    <!-- ========================================== -->
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <span>در حال بارگذاری...</span>
    </div>

    <div v-else-if="posts.length === 0" class="empty-state">
      <div class="empty-icon">📭</div>
      <h3>هنوز پستی ثبت نشده است</h3>
      <p>با کلیک روی «پست جدید» اولین نمونه کار خود را اضافه کنید.</p>
      <button class="btn-primary" @click="openCreateModal">➕ پست جدید</button>
    </div>

    <div v-else class="posts-grid">
      <post-card
          v-for="post in posts"
          :key="post.id"
          :post="post"
          @edit="openEditModal"
          @delete="deletePost"
          @pin="togglePin"
          @detail="openDetailModal"
      />
    </div>

    <!-- ========================================== -->
    <!-- صفحه‌بندی -->
    <!-- ========================================== -->
    <div v-if="pagination.last_page > 1" class="pagination">
      <button class="btn-page" :disabled="pagination.current_page <= 1" @click="handlePageChange(pagination.current_page - 1)">
        قبلی
      </button>
      <span class="page-info">
        صفحه {{ pagination.current_page }} از {{ pagination.last_page }}
      </span>
      <button class="btn-page" :disabled="pagination.current_page >= pagination.last_page" @click="handlePageChange(pagination.current_page + 1)">
        بعدی
      </button>
    </div>

    <!-- ========================================== -->
    <!-- مودال فرم -->
    <!-- ========================================== -->
    <post-form-modal
        v-if="showFormModal"
        :editing-post="editingPost"
        :lines="lines"
        @close="closeFormModal"
        @success="onFormSuccess"
    />

    <!-- ========================================== -->
    <!-- مودال جزئیات -->
    <!-- ========================================== -->
    <post-detail-modal
        v-if="showDetailModal"
        :post="detailPost"
        @close="closeDetailModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import DiskUsageBar from './DiskUsageBar.vue';
import PostCard from './PostCard.vue';
import PostFormModal from './PostFormModal.vue';
import PostDetailModal from './PostDetailModal.vue';

export default {
  name: 'PortfolioIndex',

  components: {
    DiskUsageBar,
    PostCard,
    PostFormModal,
    PostDetailModal
  },

  data: function() {
    return {
      loading: false,
      posts: [],
      lines: [],
      diskUsage: null,
      filters: { line_id: '' },
      pagination: { current_page: 1, last_page: 1, total: 0 },

      showFormModal: false,
      editingPost: null,

      showDetailModal: false,
      detailPost: null
    };
  },

  mounted: function() {
    this.loadPosts();
    this.loadLines();
    this.loadDiskUsage();
  },

  methods: {
    // ==========================================
    // بارگذاری داده‌ها
    // ==========================================
    loadPosts: async function() {
      this.loading = true;
      try {
        var params = {
          line_id: this.filters.line_id || undefined,
          page: this.pagination.current_page
        };
        var response = await axios.get('/api/admin/posts', { params: params });
        this.posts = response.data.data || [];
        this.pagination = response.data.pagination || this.pagination;
      } catch (error) {
        this.showError('خطا در بارگذاری پست‌ها');
      } finally {
        this.loading = false;
      }
    },

    loadLines: async function() {
      try {
        var response = await axios.post('/api/admin/site/get_lines');
        this.lines = response.data.orders || [];
      } catch (error) {
        console.error(error);
      }
    },

    loadDiskUsage: async function() {
      try {
        var response = await axios.get('/api/admin/disk-usage');
        this.diskUsage = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    handlePageChange: function(page) {
      if (page < 1 || page > this.pagination.last_page) return;
      this.pagination.current_page = page;
      this.loadPosts();
    },

    resetFilters: function() {
      this.filters.line_id = '';
      this.pagination.current_page = 1;
      this.loadPosts();
    },

    // ==========================================
    // مودال‌ها
    // ==========================================
    openCreateModal: function() {
      this.editingPost = null;
      this.showFormModal = true;
    },

    openEditModal: function(post) {
      this.editingPost = post;
      this.showFormModal = true;
    },

    closeFormModal: function() {
      this.showFormModal = false;
      this.editingPost = null;
    },

    openDetailModal: function(post) {
      this.detailPost = post;
      this.showDetailModal = true;
    },

    closeDetailModal: function() {
      this.showDetailModal = false;
      this.detailPost = null;
    },

    onFormSuccess: function() {
      this.closeFormModal();
      this.loadPosts();
      this.loadDiskUsage();
    },

    // ==========================================
    // عملیات
    // ==========================================
    deletePost: async function(post) {
      if (!confirm('آیا از حذف این پست اطمینان دارید؟')) return;
      try {
        await axios.delete('/api/admin/posts/' + post.id);
        this.showSuccess('پست حذف شد.');
        this.loadPosts();
        this.loadDiskUsage();
      } catch (error) {
        var msg = 'خطا در حذف پست';
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.showError(msg);
      }
    },

    togglePin: async function(post) {
      try {
        var response = await axios.post('/api/admin/posts/' + post.id + '/pin');
        this.showSuccess(response.data.message);
        this.loadPosts();
      } catch (error) {
        var msg = 'خطا';
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.showError(msg);
      }
    },

    // ==========================================
    // کمکی
    // ==========================================
    showSuccess: function(msg) {
      if (this.$toast) this.$toast.success(msg);
      else alert(msg);
    },

    showError: function(msg) {
      if (this.$toast) this.$toast.error(msg);
      else alert(msg);
    }
  }
};
</script>

<style scoped>
.portfolio-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  direction: rtl;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
}

.subtitle {
  margin: 4px 0 0 0;
  color: #909399;
  font-size: 14px;
}

.filter-section {
  background: white;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-group label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.filter-select {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 13px;
  background: white;
}

.btn-reset {
  padding: 6px 16px;
  background: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.btn-primary {
  padding: 10px 24px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.btn-primary:hover {
  background: #66b1ff;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  color: #909399;
  gap: 12px;
  background: white;
  border-radius: 12px;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.empty-state h3 {
  color: #2c3e50;
  margin-bottom: 6px;
}

.empty-state p {
  color: #909399;
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.btn-page {
  padding: 6px 16px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.btn-page:hover:not(:disabled) { background: #66b1ff; }
.btn-page:disabled { background: #c0c4cc; cursor: not-allowed; }

.page-info { font-size: 13px; color: #606266; }

@media (max-width: 768px) {
  .portfolio-page { padding: 12px; }
  .page-header { flex-direction: column; align-items: stretch; }
  .btn-primary { width: 100%; }
  .posts-grid { grid-template-columns: 1fr; }
  .filter-row { flex-direction: column; align-items: stretch; }
}
</style>